import {IName} from "../interfaces/profile-common.interface";

export function concatName(name?: IName): string {
  if (!name) {
    return '';
  }
  return `${name.first} ${name.middle} ${name.last}`;
}
